module.exports = __webpack_public_path__ + "img/cake-18.5066f570.svg";